<template>
  <div style="height: 100%; overflow: auto;">
    <div class="v-data-table-off-overflow" v-if="isLoaded">
      <v-data-table
        v-if="view === 'table1'"
        dense
        :items="table.items"
        :headers="table.headers"
        disable-pagination
        hide-default-footer
        fixed-header
      ></v-data-table>
      <div style="overflow: hidden;">
        <apexchart
          v-show="view === 'graph1'"
          type="area"
          height="350"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </div>

    <v-progress-linear
      v-else
      indeterminate
      color="success"
    ></v-progress-linear>

  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TableSl',
  props: {
    view: String,
    widget: Object,
  },
  data() {
    return {
      isLoaded: false,
      items: [],
      table: {
        items: [],
        headers: [
          {text: 'принят', value: 'accept'},
          {text: 'количество', value: 'amount'},
          {text: 'процент к принятым', value: 'percentAccepted'},
        ],
      },

      chartOptions: {
        chart: {
          // type: 'area',
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false
          },
        },
        stroke: {
          curve: 'smooth',
          width: [3, 2],
          colors: ['#50c2f7', '#d60000']
        },
        dataLabels: {
          enabled: false,
          // enabledOnSeries: [1]
        },
        legend: {
          show: false,
        },
        annotations: {
          yaxis: [
            // Пропущенные вызовы
            {
              y: 0,
              y2: 100,
              borderColor: '#FEB019',
              fillColor: '#FEB019',
              opacity: 0.4,
              label: {
                position: 'left',
                offsetX: 220,
                borderColor: '#FEB019',
                style: {
                  fontSize: '0.8rem',
                  color: '#333',
                  background: '#FEB019',
                },
                text: 'Пропущенные вызовы',
              }
            },
            // пороговый сервис
            {
              y: 90,
              borderColor: '#02a6f2',
              fillColor: '#02a6f2',
              opacity: 0.4,
              strokeDashArray: 0,
              label: {
                position: 'right',
                offsetX: -20,
                borderColor: '#02a6f2',
                style: {
                  fontSize: '0.8rem',
                  color: '#333',
                  background: '#02a6f2',
                },
                text: 'Пороговый сервис',
              }
            },
            // Процентная составляющая
            {
              y: 82,
              borderColor: '#00E396',
              strokeDashArray: 0,
              label: {
                offsetX: -10,
                borderColor: '#00E396',
                style: {
                  fontSize: '0.8rem',
                  color: '#000',
                  background: '#00E396',
                },
                text: 'Процентная составляющая',
              }
            }, 
          ],
          xaxis: [
            {
              x: 0,
              borderColor: '#df41fb',
              strokeDashArray: 0,
              label: {
                position: 'bottom',
                offsetY: 60,
                borderColor: '#df41fb',
                style: {
                  fontSize: '0.7rem',
                  color: '#fff',
                  background: '#df41fb',
                },
                text: 'Временная составляющая',
              }
            },
          ],
        },
        xaxis: {
          labels: {
            style: {
              fontSize: '0px',
            }
          }
        },
        yaxis: {
          min: 0,
          max: 100
        },
        tooltip: {
          theme: 'dark',
          custom: this.tooltip,
        },
        theme: {
          mode: 'dark'
        },
        grid: {
          show: false,
        }
      },

      series: [
        {
          type: 'area',
          name: 'Принятые',
          data: [],
        },
        {
          type: 'line',
          name: 'Пропущенные',
          data: [],
          fill: {
            colors: ['#d60000'],
          },
        }
      ],

    }
  },

  computed: {
    ...mapGetters({
    }),

    isDarkTheme() {
      return this.$vuetify.theme.isDark;
    },
  },

  watch: {
    isDarkTheme() {
      this.changeApexTheme();
    },

  },

  methods: {
    ...mapActions({
      loadTableSlWidget: 'dashboard/loadTableSlWidget',
    }),

    fillItemsForTable(items) {
      if (!items?.statistics_sl) return
      this.table.items = items.statistics_sl.map(period => ({
          accept: `В течение ${period.wait} сек.`,
          amount: period.count_call,
          percentAccepted: period.percent_call + '%',
        })
      )
    },

    fillItemsForApex(items) {
      if (!items?.statistics_sl) return
      this.series[0].data = items.statistics_sl.map(v => v.percent_call);
      // Инвертируем для рендера
      this.series[1].data = items.statistics_sl_no_answer.map(v => (100 - v.percent_call).toFixed(1)); 

      this.chartOptions.xaxis.categories = items.statistics_sl.map(v => v.wait);

      // Аннотации на график
      let missingPercent = items.all_no_answer_call / (items.all_answer_call + items.all_no_answer_call) * 100;
      let missingPercentMap = map(missingPercent, 0, 100, 100, 0);
      this.chartOptions.annotations.xaxis[0].x = items.demand_sec;

      this.chartOptions.annotations.yaxis[0].label.text = `Пропущенные вызовы: ${items.all_no_answer_call} (${missingPercent.toFixed(1)}%)`;
      this.chartOptions.annotations.yaxis[0].y = missingPercentMap;

      // Пороговый сервис аннотация
      this.chartOptions.annotations.yaxis[1].y = items.demand_answer_call;
      if (items.demand_answer_call <= missingPercentMap) {
        this.chartOptions.annotations.yaxis[1].label.text = `Пороговый сервис: ${items.demand_answer_call}%`;
      } else {
        let clr = '#f44034';
        this.chartOptions.annotations.yaxis[1].borderColor = clr;
        this.chartOptions.annotations.yaxis[1].fillColor = clr;
        this.chartOptions.annotations.yaxis[1].label.borderColor = clr;
        this.chartOptions.annotations.yaxis[1].label.style.background = clr;
        this.chartOptions.annotations.yaxis[1].label.style.color = '#ffebee';
        this.chartOptions.annotations.yaxis[1].y2 = missingPercentMap;
        this.chartOptions.annotations.yaxis[1].label.text = `Невыполнение порогового сервиса: -${(items.demand_answer_call - missingPercentMap).toFixed(1)}%`;
      }

      this.chartOptions.annotations.yaxis[2].y = items.demand_wait;
      this.chartOptions.annotations.yaxis[2].label.text = `Процентная составляющая: ${items.demand_wait}%`;


      this.isLoaded = true;

      function map(n, start1, stop1, start2, stop2, withinBounds = true) {
        const newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
        if (!withinBounds) {
          return newval;
        }
        if (start2 < stop2) {
          return constrain(newval, start2, stop2);
        } else {
          return constrain(newval, stop2, start2);
        }
      }

      function constrain(n, low, high) {
        return Math.max(Math.min(n, high), low);
      }
    },

    tooltip({ dataPointIndex: index, series }) {
      let sec = index;
      let percent = series[0][index];
      let callCount = this.table.items[index].amount;
      let missedCount = series[1][index];

      return `<div class="apexcharts-tooltip-rangebar">
        <span>
          ${sec}сек.<br>
          Принятых: ${callCount} (${percent})% <br>
          Пропущенных: ${this.items.statistics_sl_no_answer[index].count_call} (${(100 - missedCount).toFixed(1)})%
        </span>
      </div>`;
    },

    changeApexTheme() {
      if (this.isDarkTheme) {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'dark',
          },
        };
      } else {
        this.chartOptions = {
          chart: {
            background: '#00000000'
          },
          theme: {
            mode: 'light',
          },
        };
      }
    },

    async loadData() {
      this.isLoaded = false;
      let items = await this.loadTableSlWidget(this.widget.params);
      this.items = window.structuredClone(items);
      if (!items) return
      this.fillItemsForTable(items);
      this.fillItemsForApex(items);
      this.isLoaded = true;
    },
  },
  
  async mounted() {
    await this.loadData();
    this.changeApexTheme();
  },
}
</script>


<style scoped lang="scss">

</style>